(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const announcements = document.querySelectorAll('.announcement_text');
    const leftArrow = document.querySelector('.announcementbar_arrow_container.left');
    const rightArrow = document.querySelector('.announcementbar_arrow_container.right');

    // Assuming the announcement bar container is the parent element
    const announcementContainer = document.querySelector('.announcementbar_container');
    // NOTE: You might need to change '.announcementbar' to the actual selector for the parent of announcements and arrows.

    let currentIndex = 0;
    const transitionTime = 300; // Must match CSS transition duration
    let isTransitioning = false;

    // --- Touch Variables ---
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50; // Minimum distance in pixels to register a swipe

    // --- Auto-Slide Configuration ---
    const AUTOSLIDE_INTERVAL = 3200; // 3.2 seconds
    let slideTimer;

    // --- Early Exit for 0 or 1 announcement ---
    if (announcements.length <= 1) {
      if (announcements.length === 1) {
        announcements[0].classList.add('active');
      }
      if (leftArrow) leftArrow.style.display = 'none';
      if (rightArrow) rightArrow.style.display = 'none';
      return;
    }

    // Show first on load
    announcements[currentIndex].classList.add('active');

    function slideAnnouncement(direction) {
      if (isTransitioning) return;
      isTransitioning = true;

      const currentAnnouncement = announcements[currentIndex];
      const nextIndex =
        direction === 1
          ? (currentIndex + 1) % announcements.length
          : (currentIndex - 1 + announcements.length) % announcements.length;

      const nextAnnouncement = announcements[nextIndex];

      // --- Phase 1: INSTANT JUMP (Disable Transition) ---
      nextAnnouncement.classList.remove('active', 'leaving', 'leaving-reverse');
      nextAnnouncement.classList.add('no-transition');
      nextAnnouncement.style.visibility = 'visible';

      // Instantly move the next announcement to its starting off-screen position
      if (direction === 1) {
        // Coming from right (start at +100%)
        nextAnnouncement.style.transform = 'translateX(100%)';
      } else {
        // Coming from left (start at -100%)
        nextAnnouncement.style.transform = 'translateX(-100%)';
      }

      // Force Reflow to apply the instant transform change
      void nextAnnouncement.offsetWidth;

      // --- Phase 2: START ANIMATION (Enable Transition) ---
      nextAnnouncement.classList.remove('no-transition');

      // Slide out the current announcement
      if (direction === 1) {
        currentAnnouncement.classList.add('leaving'); // Slide left
      } else {
        currentAnnouncement.classList.add('leaving-reverse'); // Slide right
      }
      currentAnnouncement.classList.remove('active');

      // Slide the next announcement to the center (translateX(0))
      nextAnnouncement.classList.add('active');
      nextAnnouncement.style.transform = 'translateX(0)';

      // --- Phase 3: CLEANUP ---
      setTimeout(() => {
        // Hide the old announcement and reset its state for future use
        currentAnnouncement.classList.remove('leaving', 'leaving-reverse');
        currentAnnouncement.style.visibility = 'hidden';
        // Reset transform back to the default off-screen right
        currentAnnouncement.style.transform = 'translateX(100%)';

        currentIndex = nextIndex;
        isTransitioning = false;
      }, transitionTime);
    }

    // --- Auto-Slide and Timer Management ---

    function startAutoslide() {
      clearInterval(slideTimer);

      slideTimer = setInterval(() => {
        slideAnnouncement(1);
      }, AUTOSLIDE_INTERVAL);
    }

    // Start the automatic rotation
    startAutoslide();

    // --- Arrow Click Listeners ---

    if (rightArrow) {
      rightArrow.addEventListener('click', () => {
        slideAnnouncement(1); // next
        startAutoslide(); // Reset timer on manual slide
      });
    }

    if (leftArrow) {
      leftArrow.addEventListener('click', () => {
        slideAnnouncement(-1); // prev
        startAutoslide(); // Reset timer on manual slide
      });
    }

    // --- Touch Event Handlers (New) ---

    if (announcementContainer) {
      // 1. Record starting position of the touch
      announcementContainer.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          clearInterval(slideTimer); // Pause auto-slide immediately
        },
        false
      );

      // 2. Record ending position of the touch
      announcementContainer.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          handleGesture();
        },
        false
      );

      // Optional: Prevent default scrolling behavior on touchmove
      announcementContainer.addEventListener(
        'touchmove',
        (e) => {
          // If the scroll is mostly horizontal, prevent vertical scrolling
          const deltaX = Math.abs(e.changedTouches[0].screenX - touchStartX);
          const deltaY = Math.abs(e.changedTouches[0].screenY - e.changedTouches[0].screenY); // This is always 0, fixed below

          // Better way to check for mostly horizontal movement:
          // const currentDeltaX = Math.abs(e.changedTouches[0].screenX - touchStartX);
          // const currentDeltaY = Math.abs(e.changedTouches[0].screenY - e.changedTouches[0].screenY);

          // Let's rely on the simpler touchstart/touchend for this banner to avoid complex logic
          // e.preventDefault();
        },
        false
      );

      /**
       * Determines the swipe direction and triggers the slide.
       */
      function handleGesture() {
        const distance = touchEndX - touchStartX;

        if (Math.abs(distance) > swipeThreshold) {
          if (distance > 0) {
            // Swiped right (show previous announcement)
            slideAnnouncement(-1);
          } else {
            // Swiped left (show next announcement)
            slideAnnouncement(1);
          }
          startAutoslide(); // Reset timer after manual swipe
        } else {
          // If it was just a tap or small movement, resume autoslide
          startAutoslide();
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Check if there's a hash in the URL
    var hash = window.location.hash;
    if (!hash) return;

    // Remove the leading # and find the matching question link
    var targetId = hash.substring(1);
    var link = document.getElementById(targetId);
    if (!link) return;

    // Change this if you have a sticky header (e.g. 80)
    var HEADER_OFFSET = 0;

    // Give the theme's JS a moment to bind its events (just in case)
    setTimeout(function () {
      // Open the accordion item (if your accordion uses click)
      //link.click();

      // Scroll so the link is at the top of the viewport
      var y = link.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;

      window.scrollTo({
        top: y,
        behavior: 'smooth', // or 'auto' if you want it to jump instantly
      });
    }, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
